<div class="account-section">
  <div class="my-section-box">
    @if (true) {
      <form [formGroup]="drumBreakServiceCostsForm">
        <div class="my-section-box__headline">{{ 'common.airDiscBrake_value_calculator_drum_maintenance' | cxTranslate
        }}</div>
        <div class="my-section-box fleetInfo" id="fleetInfo">
          <div class="my-section-box-inner">
            <div class="row col-12">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="drumBreakServiceLabourCost">
                  {{ 'common.airDiscBrake_value_calculator_drumBrakeServiceLaborCost' | cxTranslate }}*
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="drumBreakServiceLabourCost" (keyup)="calculateAndSetSum()" />
                    @if (form.drumBreakServiceLabourCost.invalid && (form.drumBreakServiceLabourCost.dirty || form.drumBreakServiceLabourCost.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.form_field_required'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                    {{ 'common.airDiscBrake_value_calculator_hours_wheelend' | cxTranslate }}
                    <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                                  'common.airDiscBrake_value_calculator_drumBrakeServiceLaborCost',
                                   'common.airDiscBrake_value_calculator_popup_drumBrakeServiceLaborCost')"
                        class="btn-link">
                        <img src="/icons/question_dark_kb.svg" alt="Air Disc Break-costs Service">
                      </span>
                    </mat-dialog-actions>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="totalDrumBreakServiceUnitCost">
                  {{ 'common.airDiscBrake_value_calculator_totalDrumBrakeServiceUnitCost' | cxTranslate }}
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="totalDrumBreakServiceUnitCost" readonly />
                    @if (form.totalDrumBreakServiceUnitCost.invalid && (form.totalDrumBreakServiceUnitCost.dirty || form.totalDrumBreakServiceUnitCost.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.form_field_required'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EnduTooltip">
                    {{ 'common.airDiscBrake_value_calculator_usd_unit' | cxTranslate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row  col-12">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="drumBreakServiceAnnualFrequency">
                  {{ 'common.airDiscBrake_value_calculator_drumBrakeServiceAnnualFrequency' | cxTranslate }}*
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="drumBreakServiceAnnualFrequency"
                      (keyup)="calculateAndSetSum()" />
                      @if (form.drumBreakServiceAnnualFrequency.invalid && (form.drumBreakServiceAnnualFrequency.dirty || form.drumBreakServiceAnnualFrequency.touched)) {
                        <span class="text-danger-show"
                          >
                        {{'common.form_field_required'|cxTranslate}}</span>
                      }
                    </div>
                    <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                      {{ 'common.airDiscBrake_value_calculator_times/year' | cxTranslate }}
                      <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                                  'common.airDiscBrake_value_calculator_drumBrakeServiceAnnualFrequency',
                                   'common.airDiscBrake_value_calculator_popup_drumBrakeServiceAnnualFrequency')"
                          class="btn-link">
                          <img src="/icons/question_dark_kb.svg" alt="Air Disc Break-costs Service">
                        </span>
                      </mat-dialog-actions>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                  <label class="form-label" for="totalDrumBreakServiceFleetCost">
                    {{ 'common.airDiscBrake_value_calculator_drum_service' | cxTranslate }}
                  </label>
                  <div class="col-12 px-0 row">
                    <div class="col-8 col-xs-8 col-sm-6 pr-0">
                      <input type="text" formControlName="totalDrumBreakServiceFleetCost" readonly />
                    </div>
                    <div class="col-4 col-xs-4 col-sm-5 EnduTooltip">
                      {{ 'common.text_smartire_usd' | cxTranslate }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="airdisk-button-block">
                <button type="button" class="btn btn-primary endaSureBack visitorInfoNext yellow-btn"
                  (click)="endaSureBack()"><img src="/icons/link-right-white.svg" class="right-arrow" alt="Back">
                {{ 'common.value_calculator_back_button' | cxTranslate }}</button>
                <button type="button" class="btn btn-primary endaSureNxt visitorInfoNext yellow-btn"
                  (click)="endaSureNxt()">{{ 'common.value_calculator_next_button' | cxTranslate }}
                  <img src="/icons/link-right-white.svg" class="right-arrow" alt="Next"></button>
                </div>
              </div>
            </div>
          </form>
        }
      </div>
    </div>